"use strict";import{ActionGroup as o}from"./src/ActionGroup.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-action-group",o);
//# sourceMappingURL=sp-action-group.js.map
